import { ThunkAction } from 'redux-thunk';
import { State as LoginState } from '@telstra-connect/login';
import {
    DeletePaymentMethodStart,
    DeletePaymentMethodSuccess,
    DeletePaymentMethodError
} from '../actions/delete-payment-methods';
import {
    IDeletePaymentRequestPayload,
    IDeletePaymentMethodResponse
} from '../state/delete-payment-methods';
import { Http } from '@telstra-connect/utils';
import { getRequestIdForAlerts } from '@telstra-connect/utils/http/common/headers';
import api from '../version';

export function deletePaymentMethod(cidn?: string, accountId?: string, tid?: string, b2bUid?: string):
ThunkAction<void, LoginState.ISignInState, void> {
    return (dispatch, getState) => {
        dispatch(DeletePaymentMethodStart());
        const appendHeader = Http.deleteMethod<IDeletePaymentMethodResponse, IDeletePaymentRequestPayload>({
            url: `/billing/${api.version}/account/${accountId}/`
                    + `deletePaymentMethod?tid=${tid}&b2bUid=${b2bUid}`,
            state: getState(),
            customHeaders: {
                'company-id': cidn,
                'request-id': getRequestIdForAlerts(cidn)
            }
        });
        return appendHeader.then((result) => {
            const response: IDeletePaymentMethodResponse = result;
            dispatch(DeletePaymentMethodSuccess(response));
        })
            .catch((error) => {
                if (error.code === 422) {
                    error.response.json()
                        .then((response) => {
                            if (response?.errors[0].code === '422206') {
                                dispatch(DeletePaymentMethodError('The payment method is in use and cannot be deleted at this time.',
                                    error.code, response?.errors[0].code))
                            } else {
                                dispatch(DeletePaymentMethodError('Policy check failed on minimum payment method.',
                                    error.code, response?.errors[0].code));
                            }
                        })
                        .catch((exception) => {
                            dispatch(DeletePaymentMethodError('Error loading delete payment method.', error.code, ''));
                        })
                } else {
                    dispatch(DeletePaymentMethodError('Error loading delete payment method.', error.code, ''));
                }
            });
    };
}
